export type YValueEvent<Value> = { value: Value };
export type YInputEvent = { input: void };
export type YSelectedEvent<Value> = { selected: Value };
export type YStateEvent = { state: void };
export type YBlurEvent = { blur: void };
export type YFocusEvent = { focus: void };
export type YChangeEvent = { change: void };
export type YVoidKeys<Events> = { [K in keyof Events]: Events[K] extends void ? K : never }[keyof Events];

export type YEventHandler<Value> = (v: Value) => void;
export type YEventHandlers<Events> = { [Event in keyof Events]?: YEventHandler<Events[Event]>[] } | undefined;

export interface YEventSource<Events> {
    $handlers: YEventHandlers<Events>;
}

export function $on<Events, Key extends keyof Events>(source: YEventSource<Events>, event: Key, handler: YEventHandler<Events[Key]>): [YEventHandler<Events[Key]>[], YEventHandler<Events[Key]>] {
    let all_handlers = source.$handlers;
    if(!all_handlers)
        source.$handlers = all_handlers = {};
    let handlers = all_handlers[event];
    if(!handlers)
        all_handlers[event] = handlers = [];
    handlers.push(handler);

    return [handlers as YEventHandler<Events[Key]>[], handler];
}

export function $off<Events, Key extends keyof Events>(token: [YEventHandler<Events[Key]>[], YEventHandler<Events[Key]>]) {
    const where = token[0].indexOf(token[1]);
    if(where >= 0)
        token[0].splice(where, 1);
}

export function $trigger<Events, Key extends YVoidKeys<Events>>(source: YEventSource<Events>, event: Key): void
export function $trigger<Events, Key extends keyof Events>(source: YEventSource<Events>, event: Key, value: Events[Key]): void
export function $trigger<Events, Key extends keyof Events>(source: YEventSource<Events>, event: Key, value?: any) {
    const all_handlers = source.$handlers;
    if(!all_handlers) return;
    const handlers = all_handlers[event];
    if(!handlers) return;
    for(let i = 0; i < handlers.length; i++) {
        handlers[i](value);
    }
}
